import { setupDefaultsStorageKey, stateStorageKey, themeModeStorageKey } from "../constants";
import type { SetupDefaults, SpendingTrackerState, ThemeMode } from "../types";

export function saveTrackerState(state: SpendingTrackerState) {
  localStorage.setItem(stateStorageKey, JSON.stringify(state));
}

export function loadTrackerState() {
  const saved = localStorage.getItem(stateStorageKey);

  if (!saved) {
    return null;
  }

  try {
    return JSON.parse(saved) as SpendingTrackerState;
  } catch {
    localStorage.removeItem(stateStorageKey);
    return null;
  }
}

export function saveSetupDefaults(defaults: SetupDefaults) {
  localStorage.setItem(setupDefaultsStorageKey, JSON.stringify(defaults));
}

export function loadSetupDefaults(): SetupDefaults {
  const saved = localStorage.getItem(setupDefaultsStorageKey);

  if (!saved) {
    return {
      periodAllowance: null,
      periodType: "monthly"
    };
  }

  try {
    const defaults = JSON.parse(saved) as Partial<SetupDefaults>;

    return {
      periodAllowance: typeof defaults.periodAllowance === "number" ? defaults.periodAllowance : null,
      periodType: defaults.periodType === "weekly" || defaults.periodType === "monthly" ? defaults.periodType : "monthly"
    };
  } catch {
    localStorage.removeItem(setupDefaultsStorageKey);

    return {
      periodAllowance: null,
      periodType: "monthly"
    };
  }
}

export function saveThemeMode(themeMode: ThemeMode) {
  localStorage.setItem(themeModeStorageKey, themeMode);
}

export function loadThemeMode(): ThemeMode {
  return localStorage.getItem(themeModeStorageKey) === "dark" ? "dark" : "light";
}

export function setCookie(name: string, value: string, days: number) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

export function getCookie(name: string) {
  const cookie = document.cookie.split("; ").find((item) => item.startsWith(`${name}=`));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.split("=").slice(1).join("="));
}
